import { LeadsBenchmarkYearlyOverviewActionTypes } from './constants';

export const leadsBenchmarkYearlyOverviewDataRequestCancelled = (response) => ({
  type:
    LeadsBenchmarkYearlyOverviewActionTypes.GET_YEARLY_OVERVIEW_DATA_CANCELLED,
  response,
});

export const leadsBenchmarkYearlyOverviewDataRequestLoading = () => ({
  type:
    LeadsBenchmarkYearlyOverviewActionTypes.GET_YEARLY_OVERVIEW_DATA_LOADING,
});

/**
 * @param {import('../reducer.initialData').LeadsBenchmarkYearyOverviewDataResponse} response
 * @returns {{type: string, response: import('../reducer.initialData').LeadsBenchmarkYearyOverviewDataResponse}}
 */
export const getLeadsBenchmarkYearlyOverviewDataSuccess = ({
  result,
  currentLevel,
  currentDealerId,
}) => ({
  type:
    LeadsBenchmarkYearlyOverviewActionTypes.GET_YEARLY_OVERVIEW_DATA_SUCCESS,
  result,
  currentLevel,
  currentDealerId,
});

/**
 * @param {any} error
 * @returns {{type: string, error: any}}
 */
export const getLeadsBenchmarkYearlyOverviewDataError = (error) => ({
  type: LeadsBenchmarkYearlyOverviewActionTypes.GET_YEARLY_OVERVIEW_DATA_ERROR,
  error,
});

export const leadsYearlyOverviewApiProgressActions = {
  apiLoading: () => leadsBenchmarkYearlyOverviewDataRequestLoading(),
  apiCancelled: () => leadsBenchmarkYearlyOverviewDataRequestCancelled(),
};
